import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { QuotationService } from '../../quotation.service';

@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.css']
})
export class ProductFormComponent implements OnInit {
  @Output() productDetailShare = new EventEmitter<any>();

  constructor(private quotationService: QuotationService) { }

  ngOnInit(): void {
    // console.log(this.quotationService.onTotal())
  }

  onAddProduct(productName, productDesc, productAmt: any) {
    this.quotationService.onAddProductForm(productName.value, productDesc.value, productAmt.value);
    this.quotationService.productDetails.push(this.quotationService.productObjDetails);
    this.productDetailShare.emit(this.quotationService.productDetails);
  }
}

